import { contactData } from '@/mocks/homeData';

export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-[720px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            {contactData.title}
          </h2>
          <div className="mt-4 w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
            {contactData.description}
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            {contactData.tips.map((tip) => (
              <span
                key={tip}
                className="px-5 py-2.5 rounded-full bg-background-50 border border-background-200/70 text-sm text-foreground-700 whitespace-nowrap cursor-pointer hover:border-primary-300/50 hover:text-primary-500 transition-all duration-200"
              >
                {tip}
              </span>
            ))}
          </div>

          <div className="mt-8 inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-medium cursor-pointer hover:bg-primary-600 transition-colors duration-200">
            <i className="ri-mail-line"></i>
            <span className="whitespace-nowrap">{contactData.email}</span>
          </div>
        </div>
      </div>
    </section>
  );
}